import { makeStyles } from 'tss-react/mui';

export const useChatMessageItemHeaderStyles = makeStyles()(() => ({
  message: {
    wordBreak: 'break-all',
  },
  typography: {
    maxWidth: 220,
    lineHeight: 1.3,
  },
  nameTypography: {
    maxWidth: 170,
    lineHeight: 1.3,
    fontSize: '12px',
  },
  time: {
    lineHeight: 0.9,
    fontWeight: 300,
    fontSize: '12px',
  },
}));
